import { useMutation } from "@apollo/client";
import { BULK_IMPORT_SALES_ARGUMENTS } from "../sales-argument.queries";
import {
  BulkImportSalesArgumentsMutation,
  BulkImportSalesArgumentsMutationVariables,
} from "../../../__generated__/BulkImportSalesArgumentsMutation";

export const useBulkImportSalesArguments = () => {
  return useMutation<
    BulkImportSalesArgumentsMutation,
    BulkImportSalesArgumentsMutationVariables
  >(BULK_IMPORT_SALES_ARGUMENTS, {
    refetchQueries: ["SalesArgumentsQuery"],
  });
};
